import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const sipSettingTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Sip Setting',
  key: 'sipSettingTemplate',
  sipInfo: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['niid', 'port', 'encryptPani'],
          ['encryptKey', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      niid: {
        label: 'Network Interface ID',
        type: 'advancedSelect',
        allowCreate: true,
        initial: '',
        options: [],
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      port: {
        label: 'Port',
        type: 'text',
        initial: '34200',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      encryptPani: {
        type: 'select',
        label: 'Encrypt P-Access Network Info',
        initial: 'NONE',
        options: [
          {
            label: 'None',
            value: 'NONE',
          },
          {
            label: 'DES algorithm with ECB mode',
            value: 'DESECB',
          }
        ],
        affectedFieldsOnChange: [
          'encryptKey'
        ]
      },
      encryptKey: {
        label: 'Encryption Key',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 8
            },
            {
              type: 'regexp',
              regexp: '^([a-zA-Z0-9]){8}$',
              errorMessage: 'Encryption Key must have 8 alphanumeric characters.'
            }
          ]
        }
      },
    },
  },
  sipTimer: {
    metadata: {
      layout: {
        rows: [
          ['t1', 't2', 't4'],
          ['tc', 'td', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true'
      },
      t1: {
        label: 'Round-trip Time (secs)',
        type: 'text',
        initial: '1',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      t2: {
        label: 'Max Retransmit Interval (secs)',
        type: 'text',
        initial: '4',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      t4: {
        label: 'Max Duration (secs)',
        type: 'text',
        initial: '5',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      tc: {
        label: 'Timeout (secs)',
        type: 'text',
        initial: '185',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      td: {
        label: 'Waiting Time (secs)',
        type: 'text',
        initial: '32',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      group: {
        type: 'text',
        initial: 'lis',
        hide: 'true'
      },
      access: {
        type: 'gg',
        initial: 'lis',
        hide: 'true'
      },
    },
  },
  networkElements: {
    metadata: {
      layout: {
        rows: [
          ['netype', 'ipAddr', 'port'],
        ],
      },
    },
    fields: {
      action: {
        type: 'custom',
        customComponent: 'actionButton'
      },
      id: {
        type: 'text',
        initial: '',
        hide: 'true'
      },
      netype: {
        type: 'select',
        initial: 'SBC',
        options: [
          {
            label: 'SBC',
            value: 'SBC',
          },
        ],
        optionsTranslatable: true,
      },
      netid: {
        type: 'text',
        hide: 'true',
        initial: 'SS8_PVOIP_GROUP',
      },
      nid: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      ipAddr: {
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
            {
              type: 'IPAddress',
              invalidIPs: ['255.255.255.255'],
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      operation: {
        type: 'text',
        hide: 'true'
      },
      port: {
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535
                ]
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.'
            }
          ]
        }
      },
    }
  },
};
